
const roles = {
	admin: 'admin',
	customer_service: 'operations',
	assembly_line: 'assembly_line',
	dealer: 'dealer',
};

export default roles;